module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIwMSIgdmlld0JveD0iMCAwIDMwMSAyMDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjQ0UxMTI2IiBkPSJNLjUuNWgzMDB2MjAwSC41eiIvPjxwYXRoIGZpbGw9IiMwMDI4NjgiIGQ9Ik0uNSA1MC41aDMwMHYxMDBILjV6Ii8+PGNpcmNsZSBmaWxsPSIjRkZGIiBjeD0iMTUwLjUiIGN5PSIxMDAuNSIgcj0iNDAiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-la.svg
// module id = 1V/5
// module chunks = 2